import { Divider as CoreDivider } from '@mui/material';
import PropTypes from 'prop-types';

// because basePath and other possible props are causing React warnings
// for more info go to https://v4-0-2.material-ui.com/api/divider/
function Divider({
  absolute = false,
  component = 'hr',
  light = false,
  orientation = 'horizontal',
  variant = 'fullWidth',
}) {
  return (
    <CoreDivider
      absolute={absolute}
      component={component}
      light={light}
      orientation={orientation}
      variant={variant}
    />
  );
}

Divider.propTypes = {
  absolute: PropTypes.bool,
  component: PropTypes.string,
  light: PropTypes.bool,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  variant: PropTypes.oneOf(['fullWidth', 'inset', 'middle']),
};

export default Divider;
